import { render } from "./px-navigation-step.vue?vue&type=template&id=7505539a&scoped=true&ts=true"
import script from "./px-navigation-step.vue?vue&type=script&lang=ts"
export * from "./px-navigation-step.vue?vue&type=script&lang=ts"

import "./px-navigation-step.vue?vue&type=style&index=0&id=7505539a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7505539a"]])

export default __exports__